
export const messages = {
  en: {
    adminOwnerDetail: {
      ownerInfo: 'Owner Information',
      name: 'Name',
      sex: 'Gender',
      communityName: 'Community Name',
      personType: 'Person Type',
      personRole: 'Person Role',
      idCard: 'ID Card',
      contact: 'Contact',
      backupPhone: 'Backup Phone',
      contactPerson: 'Contact Person',
      creator: 'Creator',
      remark: 'Remark',
      house: 'House',
      car: 'Car',
      contract: 'Contract',
      member: 'Member',
      modifyRecord: 'Modify Record',
      houseFee: 'House Fee',
      paymentHistory: 'Payment History',
      account: 'Account',
      coupon: 'Coupon',
      ownerBinding: 'Owner Binding',
      complaint: 'Complaint',
      repair: 'Repair',
      visitor: 'Visitor',
      paymentReceipt: 'Payment Receipt',
      depositReceipt: 'Deposit Receipt',
      faceSync: 'Face Sync'
    },
    aRoomDetailCar: {
      placeholderCarNum: 'Please enter license plate number',
      carNum: 'License Plate',
      leaseType: 'Plate Type',
      tempCar: 'Temporary Car',
      carType: 'Vehicle Type',
      color: 'Color',
      owner: 'Owner',
      parkingSpace: 'Parking Space',
      released: 'Released',
      validity: 'Validity'
    },
    aRoomDetailMember: {
      placeholderName: 'Please enter member name',
      face: 'Face',
      name: 'Name',
      sex: 'Gender',
      personRole: 'Person Role',
      idCard: 'ID Card',
      contact: 'Contact',
      address: 'Address'
    },
    aRoomDetailContract: {
      contractName: 'Contract Name',
      contractCode: 'Contract Code',
      parentContractCode: 'Parent Contract Code',
      contractType: 'Contract Type',
      operator: 'Operator',
      amount: 'Amount',
      startTime: 'Start Time',
      endTime: 'End Time',
      createTime: 'Create Time',
      state: 'Status'
    },
    aRoomDetailComplaint: {
      type: 'Type',
      room: 'Room',
      contact: 'Contact',
      phone: 'Phone',
      status: 'Status',
      handler: 'Handler',
      handlerPhone: 'Handler Phone',
      createTime: 'Create Time',
      actions: 'Actions',
      detail: 'Detail',
      flowChart: 'Flow Chart',
      none: 'None'
    },
    aRoomDetailRepair: {
      repairId: 'Work Order Code',
      location: 'Location',
      repairType: 'Repair Type',
      repairPerson: 'Repair Person',
      contact: 'Contact',
      appointmentTime: 'Appointment Time',
      state: 'Status',
      taskProcessing: 'Task Processing',
      detail: 'Detail'
    },
    aOwnerDetailHis: {
      action: 'Action',
      operator: 'Operator',
      operateTime: 'Operate Time',
      name: 'Name',
      gender: 'Gender',
      idCard: 'ID Card',
      address: 'Address',
      add: 'Add',
      delete: 'Delete',
      modifyNew: 'Modify(New)',
      modifyOld: 'Modify(Old)'
    },
    aOwnerDetailRoomFee: {
      room: 'Room',
      feeItem: 'Fee Item',
      feeFlag: 'Fee Flag',
      feeType: 'Fee Type',
      amountReceivable: 'Amount Receivable',
      accountTime: 'Account Time',
      receivablePeriod: 'Receivable Period',
      description: 'Description',
      status: 'Status',
      operation: 'Operation',
      selectStatus: 'Select Status',
      valid: 'Valid',
      chargeEnd: 'Charge End',
      lastDegree: 'Last Degree',
      currentDegree: 'Current Degree',
      unitPrice: 'Unit Price',
      additionalFee: 'Additional Fee',
      usage: 'Usage',
      algorithm: 'Algorithm',
      feeBasedOnActual: 'Fee based on actual situation',
      fixedFee: 'Fixed Fee',
      arrearsSubtotal: 'Arrears Subtotal:',
      note1: 'Note: The receivable end time "-" means not yet receivable or charge has ended',
      note2: 'The receivable amount is -1, usually the fee item formula setting is wrong, please check'
    },
    aOwnerDetailCoupon: {
      id: 'ID',
      couponName: 'Coupon Name',
      faceValue: 'Face Value',
      validity: 'Validity',
      userName: 'User Name',
      phone: 'Phone',
      purpose: 'Purpose',
      quantity: 'Quantity',
      status: 'Status',
      effectiveTime: 'Effective Time',
      unused: 'Unused',
      used: 'Used',
      sheet: 'sheet'
    },
    aOwnerDetailVisit: {
      visitorId: 'Visitor ID',
      photo: 'Photo',
      visitor: 'Visitor',
      ownerName: 'Owner Name',
      visitReason: 'Visit Reason/Type',
      carNum: 'Car Number',
      entourage: 'Entourage',
      createTime: 'Create Time',
      visitTime: 'Visit/Departure Time',
      visitorStatus: 'Visitor Status',
      carStatus: 'Car Status',
      operation: 'Operation',
      parkingLot: ' parking lot-',
      parkingSpace: ' parking space'
    },
    aOwnerDetailAccessControl: {
      objectType: 'Object Type',
      objectName: 'Object Name',
      command: 'Command',
      status: 'Status',
      description: 'Description',
      syncTime: 'Sync Time'
    },
    adminOwnerDetailAccessControlRecord: {
      recordType: 'Record Type',
      machineName: 'Machine Name',
      userName: 'User Name',
      openType: 'Open Type',
      createTime: 'Create Time'
    },
    adminOwnerDetailChargeMachineOrder: {
      machineName: 'Machine Name',
      orderType: 'Order Type',
      userName: 'User Name',
      phone: 'Phone',
      createTime: 'Create Time',
      status: 'Status'
    }
  },
  zh: {
    adminOwnerDetail: {
      ownerInfo: '业主信息',
      name: '名称',
      sex: '性别',
      communityName: '小区名称',
      personType: '人员类型',
      personRole: '人员角色',
      idCard: '证件号',
      contact: '联系方式',
      backupPhone: '备用手机',
      contactPerson: '联系人',
      creator: '创建员工',
      remark: '备注',
      house: '房屋',
      car: '车辆',
      contract: '合同',
      member: '成员',
      modifyRecord: '修改记录',
      houseFee: '房屋费用',
      paymentHistory: '缴费历史',
      account: '账户',
      coupon: '优惠券',
      ownerBinding: '业主绑定',
      complaint: '投诉',
      repair: '报修',
      visitor: '访客',
      paymentReceipt: '缴费收据',
      depositReceipt: '预存收据',
      faceSync: '人脸同步'
    },
    aRoomDetailCar: {
      placeholderCarNum: '请填写车牌号',
      carNum: '车牌号',
      leaseType: '车牌类型',
      tempCar: '临时车',
      carType: '车辆类型',
      color: '颜色',
      owner: '业主',
      parkingSpace: '车位',
      released: '车位已释放',
      validity: '有效期'
    },
    aRoomDetailMember: {
      placeholderName: '请填写成员名称',
      face: '人脸',
      name: '名称',
      sex: '性别',
      personRole: '人员角色',
      idCard: '身份证',
      contact: '联系方式',
      address: '地址'
    },
    aRoomDetailContract: {
      contractName: '合同名称',
      contractCode: '合同编号',
      parentContractCode: '父合同编号',
      contractType: '合同类型',
      operator: '经办人',
      amount: '合同金额',
      startTime: '开始时间',
      endTime: '结束时间',
      createTime: '起草时间',
      state: '状态'
    },
    aRoomDetailComplaint: {
      type: '类型',
      room: '房屋',
      contact: '联系人',
      phone: '联系电话',
      status: '状态',
      handler: '处理人',
      handlerPhone: '处理人电话',
      createTime: '创建时间',
      actions: '操作',
      detail: '详情',
      flowChart: '流程图',
      none: '无'
    },
    aRoomDetailRepair: {
      repairId: '工单编码',
      location: '位置',
      repairType: '报修类型',
      repairPerson: '报修人',
      contact: '联系方式',
      appointmentTime: '预约时间',
      state: '状态',
      taskProcessing: '定时任务处理',
      detail: '详情'
    },
    aOwnerDetailHis: {
      action: '动作',
      operator: '操作人',
      operateTime: '操作时间',
      name: '姓名',
      gender: '性别',
      idCard: '身份证',
      address: '家庭住址',
      add: '添加',
      delete: '删除',
      modifyNew: '修改(新)',
      modifyOld: '修改(旧)'
    },
    aOwnerDetailRoomFee: {
      room: '房屋',
      feeItem: '费用项目',
      feeFlag: '费用标识',
      feeType: '费用类型',
      amountReceivable: '应收金额',
      accountTime: '建账时间',
      receivablePeriod: '应收时间段',
      description: '说明',
      status: '状态',
      operation: '操作',
      selectStatus: '请选择状态',
      valid: '有效',
      chargeEnd: '收费结束',
      lastDegree: '上期度数',
      currentDegree: '本期度数',
      unitPrice: '单价',
      additionalFee: '附加费',
      usage: '用量',
      algorithm: '算法',
      feeBasedOnActual: '费用根据实际情况而定',
      fixedFee: '固定费',
      arrearsSubtotal: '欠费小计：',
      note1: '注意：应收结束时间 "-" 表示未到应收时间或收费已结束',
      note2: '应收金额为-1 一般为费用项公式设置出错请检查'
    },
    aOwnerDetailCoupon: {
      id: '编号',
      couponName: '优惠券名称',
      faceValue: '面值',
      validity: '有效期',
      userName: '用户名称',
      phone: '手机号',
      purpose: '用途',
      quantity: '数量',
      status: '状态',
      effectiveTime: '生效时间',
      unused: '未使用',
      used: '已使用',
      sheet: '张'
    },
    aOwnerDetailVisit: {
      visitorId: '访客ID',
      photo: '照片',
      visitor: '访客',
      ownerName: '业主姓名',
      visitReason: '来访事由/类型',
      carNum: '车牌号',
      entourage: '随行人数',
      createTime: '创建时间',
      visitTime: '来访/离开时间',
      visitorStatus: '访客状态',
      carStatus: '车辆状态',
      operation: '操作',
      parkingLot: '停车场-',
      parkingSpace: '停车位'
    },
    aOwnerDetailAccessControl: {
      objectType: '对象类型',
      objectName: '对象名称',
      command: '指令',
      status: '状态',
      description: '说明',
      syncTime: '同步时间'
    },
    adminOwnerDetailAccessControlRecord: {
      recordType: '记录类型',
      machineName: '设备名称',
      userName: '用户名称',
      openType: '开门方式',
      createTime: '创建时间'
    },
    adminOwnerDetailChargeMachineOrder: {
      machineName: '设备名称',
      orderType: '订单类型',
      userName: '用户名称',
      phone: '手机号',
      createTime: '创建时间',
      status: '状态'
    },
  }
}
